<template>
  <div class="page-container">
    <div class="page-card">
      <!-- 搜索栏 -->
      <div class="page-card__header">
        <el-button type="primary" @click="openAdd">添加</el-button>
      </div>

      <!-- 数据表格 -->
      <div class="page-card__body">
        <el-table
          v-loading="listLoading"
          :data="list"
          element-loading-text="Loading"
          border
          fit
          highlight-current-row
        >
          <el-table-column align="center" label="ID" width="95">
            <template slot-scope="scope">
              {{ scope.row.id }}
            </template>
          </el-table-column>
          <el-table-column label="链接" prop="link" align="center">
          </el-table-column>
          <el-table-column label="位置" prop="position" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.position === 1">首页1</span>
              <span v-if="scope.row.position === 2">首页2</span>
              <span v-if="scope.row.position === 3">首页3</span>
              <span v-if="scope.row.position === 4">首页4</span>
            </template>
          </el-table-column>

          <el-table-column label="跳转类型" prop="link_type" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.link_type === 1">小程序</span>
              <span v-if="scope.row.link_type === 2">网页</span>
              <span v-if="scope.row.link_type === 3">本小程序Tab链接</span>
              <span v-if="scope.row.link_type === 4">本小程序内链接</span>
            </template>
          </el-table-column>

          <el-table-column label="图片" align="center">
            <template slot-scope="scope">
              <el-image
                v-if="scope.row.banner"
                :src="bannerImage + scope.row.banner"
                style="width: 300px; height: 120px"
              ></el-image>
            </template>
          </el-table-column>

          <el-table-column
            class-name="status-col"
            label="操作"
            width="160"
            align="center"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                class="action-btn--danger"
                @click="handleDelete(scope.row, list, scope.$index)"
              >删除
              </el-button>
              <el-button
                type="text"
                @click="handleUpdate(scope.row)"
              >查看
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 弹窗 - 添加广告 -->
    <el-dialog :visible.sync="addFormShow">
      <div class="page-card__header" style="border-bottom: none; justify-content: center;">
        添加广告
      </div>
      <el-form
        ref="purchaseList"
        :model="purchaseList"
        label-position="left"
        label-width="100px"
        :rules="purchaseListRules"
        style="max-width: 900px; margin-left: 50px; text-align: left"
      >
        <el-form-item label="位置" prop="position">
          <el-radio-group v-model="purchaseList.position">
            <el-radio :label="1">首页1</el-radio>
            <el-radio :label="2">首页2</el-radio>
            <el-radio :label="3">首页3</el-radio>
            <el-radio :label="4">首页4</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="链接类型" prop="link_type">
          <el-radio-group
            v-model="purchaseList.link_type"
            @input="change_type_add"
          >
            <el-radio :label="1">小程序</el-radio>
            <el-radio :label="2">网页</el-radio>
            <el-radio :label="3">本小程序Tab链接</el-radio>
            <el-radio :label="4">本小程序内链接</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item v-show="radio_type_add === 1" label="appid" prop="images">
          <el-input v-model="purchaseList.appid" />
        </el-form-item>

        <el-form-item label="链接" prop="link">
          <el-input v-model="purchaseList.link" />
        </el-form-item>

        <el-form-item v-show="false" label="图片" prop="images">
          <el-input v-model="purchaseList.banner" />
        </el-form-item>
        <el-form-item label="图片" prop="banner">
          <el-upload
            :action="imagesrc"
            :file-list="addfileList"
            :on-success="addListSuccess"
            :on-remove="addRemove"
            :before-upload="addAvatarUpload"
            list-type="picture-card"
            :headers="headers"
          >
            <i slot="default" class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel_add">取消</el-button>
        <el-button type="primary" @click="createSumbit">提交</el-button>
      </div>
    </el-dialog>

    <!-- 弹窗 - 修改广告信息 -->
    <el-dialog :visible.sync="dialogFormUpdate" title="修改广告信息">
      <el-form
        ref="updateList"
        :model="updateList"
        label-position="left"
        label-width="100px"
        :rules="rules"
        style="max-width: 900px; margin-left: 50px; text-align: left"
      >
        <el-form-item label="位置" prop="link_type">
          <el-radio-group v-model="updateList.position">
            <el-radio :label="1">首页1</el-radio>
            <el-radio :label="2">首页2</el-radio>
            <el-radio :label="3">首页3</el-radio>
            <el-radio :label="4">首页4</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="链接类型" prop="link_type">
          <el-radio-group v-model="updateList.link_type" @input="change_type">
            <el-radio :label="1">小程序</el-radio>
            <el-radio :label="2">网页</el-radio>
            <el-radio :label="3">本小程序Tab链接</el-radio>
            <el-radio :label="4">本小程序内链接</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-show="radio_type === 1" label="appid" prop="images">
          <el-input v-model="updateList.appid" />
        </el-form-item>
        <el-form-item label="链接" prop="link">
          <el-input v-model="updateList.link" />
        </el-form-item>
        <el-form-item v-show="false" label="图片" prop="images">
          <el-input v-model="updateList.images" />
        </el-form-item>

        <el-form-item label="图片" prop="images">
          <el-upload
            :action="imagesrc"
            :file-list="fileList"
            :on-success="handleListSuccess"
            :on-remove="handleRemove"
            :before-upload="beforeAvatarUpload"
            list-type="picture-card"
            :headers="headers"
          >
            <i slot="default" class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel()">取消</el-button>
        <el-button type="primary" @click="updateSumbit()">修改</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from "../../utils/api";

export default {
  filters: {
    /**
     * 状态过滤器
     * @param {string} status - 状态值
     * @returns {string} 对应的Element UI类型
     */
    statusFilter(status) {
      const statusMap = {
        published: "success",
        draft: "gray",
        deleted: "danger",
      };
      return statusMap[status];
    },
  },
  data() {
    return {
      // Banner图片基础地址
      bannerImage:
        "https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/banner/",
      // 搜索关键字
      search: "",
      // 当前行数据
      row: {},
      // 修改弹窗文件列表
      fileList: [],
      // 修改弹窗图片URL列表
      imgUrlList: [],
      // 添加弹窗文件列表
      addfileList: [],
      // 下拉选项
      options: [],
      // 添加弹窗图片URL列表
      addImgUrl: [],
      // 列表数据
      list: [],
      // 修改弹窗链接类型
      radio_type: 0,
      // 添加弹窗链接类型
      radio_type_add: 0,

      // 图片上传地址
      imagesrc: this.baseUrl + "/admin/uploadfile/banner/",
      // 上传请求头
      headers: { Authorization: "JWT " + localStorage.getItem("adminToken") },
      // 修改表单数据
      updateList: [],
      // 列表加载状态
      listLoading: true,
      // 添加弹窗显示状态
      addFormShow: false,
      // 修改弹窗显示状态
      dialogFormUpdate: false,
      // 添加表单数据
      purchaseList: {
        banner: "",
        link: "",
        type: "",
        link_type: "",
      },
      // 总条目数
      aSum: 0,
      // 当前页数
      currentPage: 1,
      // 总页数
      pageCount: 1,
      // 每页显示条目数
      pagesize: 10,
      // 添加表单验证规则
      purchaseListRules: {
        link: [{ required: true, message: "请输入链接", trigger: "blur" }],
        type: [{ required: true, message: "请输入位置", trigger: "blur" }],
        link_type: [
          { required: true, message: "请选择链接类型", trigger: "blur" },
        ],
        position: [{ required: true, message: "请选择位置", trigger: "blur" }],
      },
      // 修改表单验证规则
      rules: {
        link: [{ required: true, message: "请输入链接", trigger: "blur" }],
        type: [{ required: true, message: "请输入位置", trigger: "blur" }],
        link_type: [
          { required: true, message: "请选择链接类型", trigger: "blur" },
        ],
        position: [{ required: true, message: "请选择位置", trigger: "blur" }],
      },
    };
  },
  mounted() {},

  created() {
    // 初始化时获取广告列表
    this.fetchData();
  },

  methods: {
    /**
     * 获取广告列表数据
     */
    fetchData() {
      this.listLoading = true;
      let url = this.baseUrl + "/admin/banner/";
      api.fetchData(url).then((response) => {
        this.list = response;
        this.listLoading = false;
        this.aSum = response.data.count;
        this.currentPage = 1;
      });
    },

    /**
     * 初始化编辑弹窗的图片列表
     * @param {object} row - 当前行数据
     */
    initImage(row) {
      this.row = row;
      this.fileList = [];
      if (row.banner != null && row.banner != "") {
        this.fileList.push({ url: this.bannerImage + row.banner });
      }
    },

    /**
     * 切换修改弹窗链接类型
     * @param {number} e - 选中的类型值
     */
    change_type(e) {
      this.radio_type = e;
    },

    /**
     * 切换添加弹窗链接类型
     * @param {number} e - 选中的类型值
     */
    change_type_add(e) {
      this.radio_type_add = e;
    },

    /**
     * 修改弹窗 - 图片移除处理
     * @param {object} file - 被移除的文件
     * @param {Array} fileList - 当前文件列表
     */
    handleRemove(file, fileList) {
      this.imgUrlList = [];
      for (let i in fileList) {
        if (fileList[i].response == undefined) {
          this.imgUrlList.push(fileList[i].url);
        } else {
          this.imgUrlList.push(fileList[i].response.filename);
        }
      }
      let urlstr = this.imgUrlList.join(",");
      this.row.banner = urlstr.replaceAll(
        "https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/banner/",
        ""
      );
    },

    /**
     * 修改弹窗 - 图片上传成功回调
     * @param {object} res - 服务器响应
     * @param {object} file - 上传的文件
     */
    handleListSuccess(res, file) {
      this.imgUrlList.push(res.filename);
      let urlstr = this.imgUrlList.join(",");
      this.row.banner = urlstr.replaceAll(
        "https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/banner/",
        ""
      );
    },

    /**
     * 图片上传前校验
     * @param {object} file - 待上传的文件
     * @returns {boolean} 是否通过校验
     */
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";

      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG 或 PNG 格式!");
      }

      return isJPG;
    },

    /**
     * 添加弹窗 - 图片移除处理
     * @param {object} file - 被移除的文件
     * @param {Array} fileList - 当前文件列表
     */
    addRemove(file, fileList) {
      this.addImgUrl = [];
      for (let i in fileList) {
        if (fileList[i].response == undefined) {
          this.addImgUrl.push(fileList[i].url);
        } else {
          this.addImgUrl.push(fileList[i].response.filename);
        }
      }
      let urlstr = this.addImgUrl.join(",");
      this.purchaseList.images = urlstr.replaceAll(
        "https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/banner/",
        ""
      );
    },

    /**
     * 添加弹窗 - 图片上传成功回调
     * @param {object} res - 服务器响应
     * @param {object} file - 上传的文件
     */
    addListSuccess(res, file) {
      this.addImgUrl.push(res.filename);
      let urlstr = this.addImgUrl.join(",");
      this.purchaseList.banner = urlstr.replaceAll(
        "https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/banner/",
        ""
      );
    },

    /**
     * 添加弹窗 - 图片上传前校验
     * @param {object} file - 待上传的文件
     * @returns {boolean} 是否通过校验
     */
    addAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";

      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG 或 PNG 格式!");
      }

      return isJPG;
    },

    /**
     * 分页切换处理
     * @param {number} val - 目标页码
     */
    handleCurrentChange(val) {
      let keyword = this.search;
      getList({ page: val, type: 1, title__icontains: keyword }).then(
        (response) => {
          this.list = response.data.results;
          this.listLoading = false;
          this.aSum = response.data.count;
          this.currentPage = val;
        }
      );
    },

    /**
     * 打开添加广告弹窗
     */
    openAdd() {
      this.addFormShow = true;
    },

    /**
     * 打开创建弹窗
     */
    handleCreate() {
      this.dialogFormVisible = true;
    },

    /**
     * 打开修改弹窗并初始化数据
     * @param {object} row - 当前行数据
     */
    handleUpdate(row) {
      this.initImage(row);
      this.dialogFormUpdate = true;
      this.updateList = row;
      this.radio_type = row.link_type;
    },

    /**
     * 删除广告信息
     * @param {object} row - 当前行数据
     * @param {Array} list - 列表数据引用
     * @param {number} index - 当前行索引
     */
    handleDelete(row, list, index) {
      let id = row.id;
      let url = this.baseUrl + "/admin/banner/" + id + "/";
      this.$confirm("此操作将永久删除该广告信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          api.deleteData(url).then((response) => {
            list.splice(index, 1);
            this.$message({
              message: "删除成功",
              type: "success",
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    /**
     * 提交新增广告表单
     */
    createSumbit() {
      let url = this.baseUrl + "/admin/banner/";
      this.$refs["purchaseList"].validate((valid) => {
        if (valid) {
          api.postData(url, this.purchaseList).then((response) => {
            this.$message({
              message: "新增成功",
              type: "success",
            });

            this.addFormShow = false;
            this.purchaseList = {};
            this.addfileList = [];
            this.fetchData();
          });
        }
      });
    },

    /**
     * 提交修改广告表单
     */
    updateSumbit() {
      let url = this.baseUrl + "/admin/banner/" + this.updateList.id + "/";
      this.$refs["updateList"].validate((valid) => {
        if (valid) {
          api.patchData(url, this.updateList).then((response) => {
            if (response.status === 200) {
              this.$message({
                message: "修改成功",
                type: "success",
              });
              this.dialogFormUpdate = false;
            }
          });
        } else {
          return false;
        }
      });
    },

    /**
     * 取消修改，关闭弹窗并重置类型
     */
    cancel() {
      this.dialogFormUpdate = false;
      this.radio_type = 0;
    },

    /**
     * 取消添加，关闭弹窗
     */
    cancel_add() {
      this.addFormShow = false;
    },
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/adManage.vue